<script setup lang="ts">
import type { LinkBreadcrumbItem } from '@shared/ui/menus'

import { AppRoute } from '@shared/config'
import { NavigationBreadcrumbs } from '@shared/ui/menus'

defineOptions({
  name: 'HeaderSlotsManagement',
})

const config = computed<LinkBreadcrumbItem[]>(() => [
  {
    id: 'slots-management',
    text: 'Slots management',
    to: AppRoute.DemosSlotsManagement,
    disabled: true,
  },
])
</script>

<template>
  <NavigationBreadcrumbs :config="config" />
</template>
